import Control from 'ol/control/Control'
import { ReactNode, useEffect, useRef } from 'react'
import useMapStore from 'store/map'

import styles from './MapToolbar.module.css'

interface Props {
  children: ReactNode
}

const MapToolbar = ({ children }: Props) => {
  const map = useMapStore(s => s.map)
  const controlRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!map || !controlRef.current) return

    const control = new Control({ element: controlRef.current })
    map.addControl(control)
    return () => {
      map.removeControl(control)
    }
  }, [map])

  return (
    <div ref={controlRef} className={`ol-unselectable ol-control ol-control-custom ${styles.toolbar}`}>
      {children}
    </div>
  )
}

export default MapToolbar
